import { THEME_ENUM } from '@/constants/theme.constant'


/**
 * Since some configurations need to be match with specific themes,
 * we recommend to use the configuration that generated from demo.
 */
export const themeConfig = {
    themeColor: 'brand',
    direction: THEME_ENUM.DIR_RTL,
    mode: typeof window != 'undefined' && !window.matchMedia('(prefers-color-scheme: dark)').matches ? THEME_ENUM.MODE_LIGHT : THEME_ENUM.MODE_DARK,
    primaryColorLevel: 600,
    cardBordered: true,
    panelExpand: false,
    controlSize: 'md',
    navMode: THEME_ENUM.NAV_MODE_DARK,
    layout: {
        type: THEME_ENUM.LAYOUT_TYPE_MODERN,
        sideNavCollapse: false
    }
}
